<template>
  <div>
    <el-row :gutter="12">
      <el-col class="left_list" :span="6" :style="{height:img_height}">
        <el-card>
          <div slot="header" class="menu_header">
            <h2><i class="el-icon-menu"></i> 结构信息</h2>
          </div>
          <div>
            <el-tree
            :data="menu_list"
            node-key="value"
            :current-node-key="currentNodeKey"
            :default-expanded-keys="expanded_keys"
            highlight-current
            @node-click="node_click"
            ref="menu_tree"
            >
              <span
              class="custom-tree-node"
              slot-scope="{node,data}">
                <i v-if="!node.isLeaf"
                class="el-icon-caret-bottom"
                style="margin-left: 8px;"></i>
                <span>{{data.areaName}}</span>
              </span>
            </el-tree>
          </div>
        </el-card>
      </el-col>
      <el-col :span="18" class="content_bg" :style="{height:img_height}">
        <!-- <el-card>
          <div slot="header">
            <el-button icon="el-icon-rank" size="mini" type="primary">全屏</el-button>
            <el-button icon="el-icon-caret-right" size="mini" type="primary">自动轮播</el-button>
          </div>
        </el-card> -->
        <div class="content_header">
          <el-button
          icon="el-icon-rank"
          size="mini"
          @click="toggleFullScreen"
          type="primary">{{$store.state.full_screen_text}}</el-button>
          <el-button
          icon="el-icon-caret-right"
          size="mini"
          @click="to_scroll"
          type="primary">{{scroll_flag}}</el-button>
        </div>
        <img :src="now_area_img+'?auth_token='+upload_token"/>
        <div
        class="drag_div"
        v-for="(item,index) in temp_data"
        :style="{left:item.xpercent,top:item.ypercent}"
        :title="item.pointName"
        >
          <el-button
          size="mini"
          @click="point_to_manage(item.warehouseId,item.pointAreaId,item.pointName)"
          slot="reference">
            <span
            v-if="item.pointTypeText=='温度计'"
            :class="[item.normal==false?'active_class':'',item.activeFlag==false?'relative_class':'']"
            class="iconfont icon-wendu">{{item.data}}℃</span>
            <span
            v-if="item.pointTypeText=='湿度计'"
            :class="[item.normal==false?'active_class':'',item.activeFlag==false?'relative_class':'']"
            class="iconfont icon-shidu">{{item.data}}%</span>
          </el-button>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  export default{
    data() {
      return{
        upload_token:localStorage.getItem(localStorage.getItem('userName')+'token'),
        //菜单列表
        menu_list:[],
        //菜单选中项
        currentNodeKey:2,
        //默认展开的节点
        expanded_keys:[1],
        //当前区域id
        now_area_id:'',
        //当前区域图
        now_area_img:'',
        //自动轮播初始化
        scroll_temp:null,
        //自动轮播开关
        scroll_status:true,
        scroll_flag:'开始轮播',
        //温控点列表
        temp_data:[],
        img_height:600+'px'
      }
    },
    created() {
      //获取菜单列表
      this.get_menu_list()
    },
    mounted() {
      window.addEventListener('keydown',(event)=>{
        const e=event||window.event
        if(e&&e.keyCode==122){
          e.preventDefault()
        }
      })
    },
    beforeDestroy() {
      clearInterval(this.scroll_temp)
    },
    methods:{
      //获取菜单列表
      get_menu_list(){
        this.$axios({
          method:'get',
          url:this.publicAjax.extra_path+'/middle/overView/warehouseDetail/areaTree'
        }).then(data=>{
          if(data.data.success==true){
            this.menu_list=data.data.data
            this.now_area_id=this.menu_list[0].children[0].areaId
            this.now_area_img=this.menu_list[0].children[0].imageUrl
            //获取温控点列表
            this.get_temp_list()
          }else{
            this.$message.warning(data.data.message)
          }
        })
      },
      //树形结构点击事件
      node_click(data){
        this.currentNodeKey=data.value
        if(data.children==null){
          this.now_area_id=data.areaId
          this.now_area_img=data.imageUrl
          //获取温控点列表
          this.get_temp_list()
        }
      },
      //获取温控点列表
      get_temp_list(){
        this.$axios({
          method:'get',
          url:this.publicAjax.extra_path+'/middle/overView/warehouseDetail/data/'+this.now_area_id
        }).then(data=>{
          if(data.data.success==true){
            if(data.data.data){
              this.temp_data=data.data.data
            }else{
              this.temp_data=[]
            }
          }else{
            this.$message.warning(data.data.message)
          }
        })
      },
      //自动轮播
      to_scroll(){
        let height=document.querySelector('.el-tree-node__content').scrollHeight
        let offset_height=document.querySelector('.el-card__header').scrollHeight
        let k=0,l=0,total=0
        for(let i=0;i<this.menu_list.length;i++){
          k++
          if(this.menu_list[i].children.length>0){
            for(let j=0;j<this.menu_list[i].children.length;j++){
              l++
            }
          }
          total=k+l
        }
        if(this.scroll_status==true){
          this.scroll_status=false
          this.scroll_flag='停止轮播'
          this.scroll_temp=setInterval(()=>{
            this.$refs.menu_tree.setCurrentKey(this.currentNodeKey)
            if(this.$refs.menu_tree.getNode(this.currentNodeKey).childNodes.length>0){
              this.expanded_keys=[this.currentNodeKey]
            }else{
              this.now_area_id=this.$refs.menu_tree.getNode(this.currentNodeKey).data.areaId
              this.now_area_img=this.$refs.menu_tree.getNode(this.currentNodeKey).data.imageUrl
              //获取温控点列表
              this.get_temp_list()
            }
            document.querySelector('.left_list').scrollTop=height*this.currentNodeKey-offset_height
            this.currentNodeKey++
            if(this.currentNodeKey>total){
              this.currentNodeKey=1
            }
          },5000)
        }else{
          this.scroll_status=true
          this.scroll_flag='开始轮播'
          clearInterval(this.scroll_temp)
        }
      },
      //全屏/退出全屏
      toggleFullScreen(){
        //控制菜单栏显隐
        this.$store.state.side_flag=!this.$store.state.side_flag
        if(this.$store.state.side_flag==true){
          this.$store.state.side_left=-260+'px'
          this.$store.state.body_left=40+'px'
        }else{
          this.$store.state.side_left=''
          this.$store.state.body_left=''
        }
        this.$store.state.full_screen=!this.$store.state.full_screen
        if(this.$store.state.full_screen==true){
          //全屏模式
          this.$store.state.full_screen_text='退出全屏'
          this.$store.state.search_form_show=false
          const elem=document.documentElement
          if(elem.requestFullscreen){
            elem.requestFullscreen()
          }else if(elem.mozRequestFullScreen){
            elem.mozRequestFullScreen()
          }else if(elem.webkitRequestFullscreen){
            elem.webkitRequestFullscreen()
          }else if(elem.msRequestFullscreen){
            elem.msRequestFullscreen()
          }
          window.onresize=()=>{
            return (()=>{
              this.img_height=window.innerHeight+'px'
            })()
          }
        }else{
          //退出全屏
          this.$store.state.full_screen_text='全屏'
          this.$store.state.search_form_show=true
          if(document.exitFullscreen){
            document.exitFullscreen()
          }else if(document.mozCancelFullScreen){
            document.mozCancelFullScreen()
          }else if(document.webkitExitFullscreen){
            document.webkitExitFullscreen()
          }else if(document.msExitFullscreen){
            document.msExitFullscreen()
          }
          window.onresize=()=>{
            return (()=>{
              this.img_height=600+'px'
            })()
          }
        }
      },
      //路由跳转公共函数
      get_router(path,path_name,row){
        let router_list=[]
        this.$store.state.openTab.forEach((item,index)=>{
          router_list.push(item.route)
        })
        if(router_list.includes(path)){
          this.$store.commit('delete_tabs',path)
        }
        this.$store.commit('add_tabs',{
          route:path,
          name:path_name
        })
        this.$store.commit('set_active_index',path)
        this.$router.push({
          path:path,
          query:{
            row:row
          }
        })
      },
      //跳转库房管理页面
      point_to_manage(warehouseId,areaId,pointName){
        this.get_router('/cold/warehouse_manage','库房管理',{
          warehouseId:warehouseId,
          areaId:areaId,
          pointName:pointName
        })
      }
    }
  }
</script>

<style scoped>
  .left_list{
    overflow-y: auto;
  }
  .menu_header h2{
    font-weight: 600;
  }
  .menu_header i{
    color: rgb(64, 158, 255);
  }
  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;
    padding-right: 8px;
  }
  .left_list /deep/ .el-icon-caret-right{
    display: none;
  }
  /deep/ .el-tree-node__content{
    padding: 10px 0;
  }
  .content_bg{
    position: relative;
  }
  .content_header{
    position: absolute;
    top: 0;
    left: 10px;
    height: 30px;
  }
  .content_bg img{
    width: 100%;
    height: 100%;
  }
  .drag_div{
    position: absolute;
    width: auto;
    height: auto;
  }
  .drag_div:hover{
    z-index: 2;
  }
  .active_class{
    color: red;
  }
  .relative_class{
    color: gold;
  }
</style>



// WEBPACK FOOTER //
// src/components/cold/cold_storage_detail.vue